import { memo } from 'react';
import { Handle, Position, NodeProps } from '@xyflow/react';
import { Clock } from 'lucide-react';

function formatDuration(seconds: number): string {
  if (seconds >= 86400 && seconds % 86400 === 0) return `${seconds / 86400} day(s)`;
  if (seconds >= 3600 && seconds % 3600 === 0) return `${seconds / 3600} hour(s)`;
  if (seconds >= 60 && seconds % 60 === 0) return `${seconds / 60} minute(s)`;
  return `${seconds}s`;
}

function WaitDurationNode({ data, selected }: NodeProps) {
  const config = (data.config as Record<string, unknown>) ?? {};
  const duration = (config.duration as number) ?? 0;

  return (
    <div
      className={`w-52 rounded-xl bg-white shadow-sm border border-zinc-200 border-l-4 border-l-amber-500 ${
        selected ? 'ring-2 ring-emerald-400' : ''
      }`}
    >
      <Handle type="target" position={Position.Top} className="!bg-amber-500" />
      <div className="flex items-center gap-2 px-3 py-2 border-b border-zinc-100">
        <Clock size={14} className="text-amber-500 shrink-0" />
        <span className="text-xs font-semibold text-zinc-700 uppercase tracking-wide">
          Wait
        </span>
      </div>
      <div className="px-3 py-2">
        <p className="text-xs text-zinc-500">Duration</p>
        <p className="text-xs text-zinc-800 font-medium">
          {duration ? formatDuration(duration) : <span className="italic text-zinc-400">Not set</span>}
        </p>
      </div>
      <Handle type="source" position={Position.Bottom} className="!bg-amber-500" />
    </div>
  );
}

export default memo(WaitDurationNode);
